// 수업 리뷰 > AI 진단 개요 > 추천 학습 영역
import { QIcon_chevron_bold_right } from '@repo/icons/index'

import { HighlightOverviewResponse } from '../../../../model/caf.interface'
import { DESCRIPTION_CLX } from '../../../../modules/consts/caf'
import LoadingSpinner from '../../../common/LoadingSpinner'
import SimpleHighlight from './SimpleHighlight'

import { useCafHighlightListV5 } from '../../../../modules/apis/webview/caf'
import useAppRouter from '../../../../modules/hooks/common/useAppRouter'
import useIsMobile from '../../../../modules/hooks/common/useIsMobile'
import useIsWebview from '../../../../modules/hooks/common/useIsWebview'
import useWebviewNavigation from '../../../../modules/hooks/webview/common/useWebviewNavigation'
import { n_caf } from '../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../modules/i18n/useTranslation'
import urls from '../../../../modules/urls'
import { COLORS } from '../../../../modules/vars'
import { LESSON_ACTIVITIES_MAP, useLessonsStack } from '../../../../pages/[lang]/webview/lessons'

const HighlightListSection = ({ lessonId, level }) => {
  const { t } = useTranslation()
  const isMobile = useIsMobile()
  const router = useAppRouter()
  const isWebview = useIsWebview()
  const { useLessonsFlow } = useLessonsStack()
  const { push } = useLessonsFlow()
  const { data, isLoading } = useCafHighlightListV5<HighlightOverviewResponse>({
    lessonId,
    recommended: true,
    show_details: true,
  })

  const { navigate } = useWebviewNavigation()
  const goHighlightPage = () => {
    if (isWebview) {
      push(LESSON_ACTIVITIES_MAP.AIOverviewHighlightListActivity, { pinned: false, lessonId })
    } else if (isMobile) {
      const url = urls.webview.caf.highlight.lesson_list(lessonId, level)
      navigate({ url })
    } else {
      router.push(urls.student.newPortal.lessons.reviewDetail.asCaf(lessonId, 5))
    }
  }

  if (isMobile) {
    return (
      <section className="pt-[16px] pb-[16px]">
        <h2 className="text-sTitle mb-[12px] font-bold text-black">{t(n_caf.overview.highlight_title)}</h2>
        <p className={`${DESCRIPTION_CLX} mb-[16px]`}>{t(n_caf.overview.highlight_detail)}</p>
        {isLoading && (
          <div className="flex min-h-[200px] items-center">
            <LoadingSpinner lg primary show />
          </div>
        )}
        {data?.highlights?.map((highlightItem) => (
          <SimpleHighlight key={highlightItem.id} highlightItem={highlightItem} type="recommended" />
        ))}
        <div className="mt-16 flex justify-end">
          <div
            className="Body2-14Bd flex cursor-pointer items-center justify-end text-gray-600"
            onClick={goHighlightPage}
          >
            {t(n_caf.overview.highlight_seeall)}
            <QIcon_chevron_bold_right className="ml-5" height={12} width={12} color={COLORS.BLACK} />
          </div>
        </div>
      </section>
    )
  } else {
    return (
      <section className="flex w-full flex-col py-[32px]">
        <div className="mb-[8px] flex flex-row items-center justify-between">
          <h2 className="text-[20px] font-bold text-black">{t(n_caf.overview.highlight_title)}</h2>
          <div className="flex hidden cursor-pointer flex-row items-center xl:flex" onClick={goHighlightPage}>
            <div className="Body2-14Bd text-black">{t(n_caf.overview.highlight_seeall)}</div>
            <QIcon_chevron_bold_right className="ml-2" height={16} width={16} color={COLORS.GRAY500} />
          </div>
        </div>
        <div className="pb-[24px]">
          <span className={`text-[16px] text-gray-600`}>{t(n_caf.overview.highlight_detail)}</span>
        </div>
        {isLoading ? (
          <div className="flex h-[198px] w-[100%] flex-row items-center justify-center">
            <LoadingSpinner show primary lg />
          </div>
        ) : (
          <div className="flex w-[596px] flex-wrap gap-[16px] sm:w-[352px] lg:w-[596px] xl:w-[688px]">
            {data?.highlights?.map((highlightItem) => (
              <SimpleHighlight key={highlightItem.id} highlightItem={highlightItem} type="recommended" />
            ))}
          </div>
        )}
        <div className="mt-[24px] flex flex-row items-center justify-end xl:hidden">
          <div className="Body2-14Bd flex cursor-pointer items-center text-black" onClick={() => goHighlightPage()}>
            {t(n_caf.overview.highlight_seeall)}
            <QIcon_chevron_bold_right className="ml-2" height={16} width={16} color={COLORS.GRAY500} />
          </div>
        </div>
      </section>
    )
  }
}

export default HighlightListSection
